import { DragOverlay, useDroppable } from "@dnd-kit/core";
import NormalInput from "../../../FormBuilderInputs/NormalInput";
import AntCalendar from "../../../FormBuilderInputs/Calendar";
import AntCheckBox from "../../../FormBuilderInputs/CheckBox";
import AntDatePicker from "../../../FormBuilderInputs/DatePicker";
import DropdownInput from "../../../FormBuilderInputs/DropdownInput";
import RadioGroup from "../../../FormBuilderInputs/RadioGroup";
import AntTextArea from "../../../FormBuilderInputs/TextArea";
import Toggle from "../../../FormBuilderInputs/Toggle";
import AntUpload from "../../../FormBuilderInputs/Upload";
import AntButton from "../../../FormBuilderInputs/Button";
import AntHeader from "../../../FormBuilderInputs/Header";
import Image from "../../../FormBuilderInputs/Image";
import Label from "../../../FormBuilderInputs/Label";
import Link from "../../../FormBuilderInputs/Link";
import ProgressCircle from "../../../FormBuilderInputs/ProgressCircle";
import ProgressLine from "../../../FormBuilderInputs/ProgressLine";
import Signature from "../../../FormBuilderInputs/Signature";
import Container from "../../../FormBuilderInputs/MultiInputs";
import {
	SortableContext,
	verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import FormDroppableItems from "./FormDroppableItems";
import SnippetCamera from "../../../FormBuilderInputs/Camera";
import { useEffect, useRef } from "react";
import trans from "../../../../utils";

export default function FormDroppable({
	items,
	activeInput,
	setActiveInput,
	setDroppedItems,
	handleDragEnd,
	collapsed,
	active,
	setActive,
	addForm,
	submitAttempt,
	direction,
}) {
	const { setNodeRef, isOver } = useDroppable({
		id: "task-droppable",
	});
	const containerRef = useRef(null);
	const isDragging = !!active;
	useEffect(() => {
		if (!isDragging) return;
		const container = containerRef.current;
		if (!container) return;

		const scrollSpeed = 10;
		const edgeOffset = 100;

		const handleDragScroll = (e) => {
			const { top, bottom } = container.getBoundingClientRect();
			const mouseY = e.clientY;

			if (mouseY < top + edgeOffset) {
				container.scrollTop -= scrollSpeed;
			} else if (mouseY > bottom - edgeOffset) {
				container.scrollTop += scrollSpeed;
			}
		};

		window.addEventListener("dragover", handleDragScroll);
		return () => {
			window.removeEventListener("dragover", handleDragScroll);
		};
	}, [isDragging]);

	const getInputType = (item) => {
		switch (item?.name) {
			case "Calendar":
				return <AntCalendar item={item} activeInput={activeInput} />;
			case "Checkbox":
				return <AntCheckBox item={item} activeInput={activeInput} />;
			case "DatePicker":
				return <AntDatePicker item={item} activeInput={activeInput} />;
			case "Dropdown":
				return <DropdownInput item={item} activeInput={activeInput} />;

			case "Input":
				return <NormalInput item={item} activeInput={activeInput} />;
			case "Container":
				return (
					<Container
						handleDragEnd={handleDragEnd}
						getInputType={getInputType}
						css={item?.css}
						container={item?.container}
						setActiveInput={setActiveInput}
						activeInput={activeInput}
						active={active}
						setActive={setActive}
						setDroppedItems={setDroppedItems}
						containerKey={item?.key}
						submitAttempt={submitAttempt}
						item={item}
					/>
				);
			case "Radio_group":
				return <RadioGroup item={item} activeInput={activeInput} />;

			case "Text_area":
				return <AntTextArea item={item} activeInput={activeInput} />;

			case "Toggle":
				return <Toggle item={item} activeInput={activeInput} />;
			case "Uploader":
				return <AntUpload item={item} activeInput={activeInput} />;
			case "Button":
				return <AntButton item={item} activeInput={activeInput} />;

			case "Header":
				return <AntHeader item={item} activeInput={activeInput} />;
			case "Image":
				return <Image item={item} activeInput={activeInput} />;
			case "Label":
				return <Label item={item} activeInput={activeInput} />;
			case "Link":
				return <Link item={item} activeInput={activeInput} />;

			case "Progress_circle":
				return <ProgressCircle item={item} />;
			case "Progress_line":
				return <ProgressLine item={item} />;
			case "Signature":
				return <Signature item={item} setDroppedItems={setDroppedItems} />;
			case "Camera":
				return <SnippetCamera item={item} />;
			default:
				return item?.name;
		}
	};

	return (
		<div
			ref={setNodeRef}
			style={{
				maxHeight: "calc(100vh - 121px)",
				border: "1px dashed gray",
				backgroundColor: isOver ? "#0f69361f" : "#fafafa",
				padding: "20px",
				width:
					collapsed.inputsCollapsed && collapsed.optionsCOllapsed
						? "98%"
						: collapsed.inputsCollapsed || collapsed.optionsCOllapsed
						? "73%"
						: "50%",
				overflowY: "scroll",
				position: "relative",
			}}
			dir={direction ? "ltr" : "rtl"}
		>
			{items?.length === 0 && (
				<h4
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						height: "100%",
					}}
				>
					{trans("Drop Area")}
				</h4>
			)}
			<SortableContext
				items={items.map((item) => item.key)}
				strategy={verticalListSortingStrategy}
			>
				{items.map((item, index) => (
					<>
						<div
							key={item.key}
							style={{
								marginBottom:
									index === items.length - 1 && isDragging ? "120px" : "0px",
								transition: "margin 0.2s",
							}}
						>
							<FormDroppableItems
								key={item.key}
								item={item}
								getInputType={getInputType}
								activeInput={activeInput}
								setActiveInput={setActiveInput}
								setDroppedItems={setDroppedItems}
								active={active}
								setActive={setActive}
								allItems={items}
								addForm={addForm}
								submitAttempt={submitAttempt}
							/>
						</div>
					</>
				))}
				<DragOverlay>
					{activeInput ? (
						<div
							style={{
								width: "160px",
								height: "30px",
								background: "linear-gradient(135deg, #2e9245 0%, #1b5e20 100%)",
								color: "#fff",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								borderRadius: "6px",
								boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
								fontWeight: "600",
								fontSize: "13px",
								letterSpacing: "0.5px",
								textTransform: "capitalize",
								cursor: "grabbing",
								zIndex: 9999,
							}}
						>
							{activeInput}
						</div>
					) : null}
				</DragOverlay>
			</SortableContext>
		</div>
	);
}
